import axios from "axios";


const instance = axios.create({
    baseURL: "http://localhost:5001/amazone-clone-app/us-central1/api"
})

export default instance